import "./styles.css";
import {
  useMantineTheme,
  Radio,
  ScrollArea,
  Title,
  Text,
  Flex,
  ActionIcon,
  LoadingOverlay,
  Box,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectedFolder } from "../../store/reducers/root";
import { Reload } from "tabler-icons-react";

export default function FolderSelector({ refresh, setRefresh, loading }) {
  const theme = useMantineTheme();
  const folders = useSelector((state) => state.channels);
  const folder = useSelector((state) => state.folder);
  const dispatch = useDispatch();
  const [folderSelected, setFolderSelected] = useState(null);

  useEffect(() => {
    if (folderSelected) {
      dispatch(selectedFolder(folderSelected));
    }
  }, [folderSelected]);

  return (
    <>
      <Title size={"h1"} mt={"50px"} align="center">
        Telegram Folder Message
      </Title>
      <Text size={"18px"} color="dimmed" maw={"400px"} mb={"40px"}>
        Please select a folder you’d like to message
      </Text>
      <Flex justify={"flex-end"}>
        <ActionIcon
          size="md"
          color={"dark"}
          onClick={() => setRefresh(!refresh)}
        >
          <Reload size={"100%"} />
        </ActionIcon>
      </Flex>

      <Box h={"inherit"}>
        <LoadingOverlay visible={loading} overlayBlur={2} />
        <ScrollArea h={"100%"} offsetScrollbars mb={"40px"}>
          <Radio.Group
            w={"100%"}
            className="radioGroupCustom"
            value={folderSelected?.index}
            onChange={(e) => {
              setFolderSelected(folders[e]);
            }}
          >
            {folders.map((folder, index) => {
              return (
                <label key={index} style={{ width: "100%" }}>
                  <Radio
                    labelPosition="left"
                    label={
                      folder.icon
                        ? `${folder.icon} - ${folder.label}`
                        : `${folder.label}`
                    }
                    value={folder.index}
                    color={theme.colorScheme === "dark" ? "gray" : "dark"}
                  />
                </label>
              );
            })}
          </Radio.Group>
        </ScrollArea>
      </Box>

      {!!folder && (
        <>
          <Text color={"dimmed"}>Folder Selected: </Text>
          <Text>{`${folder.label}`}</Text>
        </>
      )}
    </>
  );
}
